<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { ref } from "vue";
import { useStorage } from "@vueuse/core";

const hasSeenNotification = useStorage("has-seen-notification", false, sessionStorage);
const props = defineProps({
    initialActive: {
        type: Boolean,
        default: false,
    },
    persistent: {
        type: Boolean,
        default: false,
    }
});
const isActive = ref(props.persistent && hasSeenNotification.value ? false : props.initialActive);
console.log(props.persistent)
console.log(hasSeenNotification.value)
console.log(isActive.value)
const toggle = () => {
    isActive.value = !isActive.value;
};
const toggleWithStorage = () => {
    isActive.value = !isActive.value;
    hasSeenNotification.value = true;
};
</script>

<template>
    <slot v-bind="{ isActive, toggle, toggleWithStorage }" />
</template>
